//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  props: {
    laiseeInfo: {
      type: Object,
      default: null
    },
    laiseeStatus: {
      type: Object,
      default: null
    }
  },
  computed: {
    tipText: function tipText() {
      if (this.laiseeStatus.isTotalLimit) {
        return '你已达活动红包领取上限';
      }

      if (this.laiseeStatus.isDayLimit) {
        return '你已达到当天领取上限';
      }

      if (this.laiseeStatus.isFetched) {
        return '该红包你已领取过~';
      }

      if (this.laiseeStatus.isFinish && this.isOwner) {
        return '恭喜你！红包已被3位好友领完，福袋已到账，快去看看吧';
      }

      if (this.laiseeStatus.isFinish) {
        return '会员红包已领完~';
      }

      return '会员红包已过期～';
    }
  },
  components: {
    Avatar: Avatar
  }
};